import { SET_SHOW_MODAL } from "../const/actionType";

export const setShowModal = (value) => (dispatch) => {
    //console.log("generalAction.setShowModal value: " + value);
    dispatch({
        type: SET_SHOW_MODAL,
        payload: value
    });
}